import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useState } from 'react';
import TickIcon from '../../../../../assets/pdp/tick.svg';
import ConfigModal from './configModal';

export interface VariantConfiguration {
	configurations: Configuration[];
	product: any;
}

export interface Configuration {
	label: string;
	options: Option[];
	name: string;
}
export interface Option {
	value: string;
	selected?: boolean;
}
export interface IVariantConfiguration {
	variantConfiguration: VariantConfiguration;
	variantGroupId: number;
	label?: string;
	condition?: string;
	priceData: any;
	promiseDate: any;
	setConfiguration: Function;
	selectedTenure: number;
	isAvailable: boolean;
}

const VariantConfiguration = (props: IVariantConfiguration) => {
	const [openConfigModel, setOpenConfigModel] = useState(false);
	return (
		<FlexBox direction='column'>
			{props?.variantConfiguration.configurations?.map((configs, index) => {
				const selectedConfig = configs.options.filter((d) => d.selected);
				const totalConfig = configs.options.length - 1;
				const labelName = configs.label;
				return (
					<>
						<LencoTypography
							sx={{
								...getStyle('H14_Medium'),
								color: getColor('Gray -1'),
								paddingBottom: '8px',
							}}
						>
							{labelName} :
						</LencoTypography>
						<FlexBox>
							<FlexBox
								onClick={() => {
									setOpenConfigModel(true);
								}}
								sx={{
									backgroundColor: '#FFFFFF',
									border: `1px solid ${getColor('Minty +1')}`,
									padding: '8px 18px 8px 18px',
									borderRadius: '4px',
									cursor: 'pointer',
									color: getColor('Minty +1'),
									marginBottom: '24px',
								}}
							>
								<Box sx={{ paddingRight: '4px' }}>
									<TickIcon />
								</Box>
								<LencoTypography
									sx={{
										...getStyle('Small_SemiBold'),
										whiteSpace: 'nowrap',
										paddingTop: '2px',
									}}
								>
									{selectedConfig[0].value}
								</LencoTypography>
							</FlexBox>
							{totalConfig > 0 && (
								<FlexBox
									onClick={() => {
										setOpenConfigModel(true);
									}}
									sx={{
										backgroundColor: '#FFFFFF',
										border: `1px solid ${getColor('Gray -4')}`,
										padding: '8px 18px 8px 18px',
										width: '102px',
										borderRadius: '4px',
										cursor: 'pointer',
										marginLeft: '16px',
										marginBottom: '24px',
										'&:hover': {
											background: getColor('Minty +1'),
											color: getColor(''),
										},
									}}
								>
									<LencoTypography
										sx={{ ...getStyle('Small_SemiBold'), whiteSpace: 'nowrap' }}
									>
										{`+${totalConfig}`} {totalConfig > 1 ? 'options' : 'option'}
									</LencoTypography>
								</FlexBox>
							)}
						</FlexBox>
						<ConfigModal
							variantConfiguration={props.variantConfiguration}
							label={props.label}
							condition={props.condition}
							variantGroupId={props.variantGroupId}
							priceData={props.priceData}
							promiseDate={props.promiseDate}
							setConfiguration={props.setConfiguration}
							selectedTenure={props.selectedTenure}
							setOpenConfigModel={setOpenConfigModel}
							openConfigModel={openConfigModel}
							isAvailable={props?.isAvailable}
						/>
					</>
				);
			})}
		</FlexBox>
	);
};

export default VariantConfiguration;
